import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  OnChanges,
  AfterViewInit,
  HostListener,
  SimpleChanges,
} from '@angular/core';
import { OmniChatFacade } from '@cigna/omni/chat-state';
import { OmniConversationsFacade } from '@cigna/omni/conversations-state';

@Component({
  selector: 'cigna-omni-shell-prechat-header',
  templateUrl: './chat-header.component.html',
  styleUrls: ['./chat-header.component.scss'],
})
export class OmniShellChatHeaderComponent implements OnChanges, AfterViewInit {
  @ViewChild('headerTitle')
  headerTitle: ElementRef;

  public isBackButtonDisabled$ = this.facade.isBackButtonDisabled$;
  public title$ = this.facade.headerTitle$;
  public headerBackgroundClass$ = this.facade.headerBackgroundClass$;
  public isUnmuted$ = this.facade.isUnmuted$;
  public toggleButton$ = this.facade.toggleChatStateButton$;
  public shouldCloseOrExit$ = this.conversationsFacade.closeOrExitFlag$;

  @Input() public isHistory: boolean;
  @Input() public existingConvId: string;
  @Input() public shouldCloseSplashScreen: boolean;
  @Input() public shouldFocusOnHeader: boolean;

  @Output() public printEmitter: EventEmitter<void> = new EventEmitter();

  isMenuOpen = false;

  @HostListener('document:click', ['$event'])
  documentClick(event: MouseEvent) {
    const e = event.target as HTMLElement;

    // We do not want to close the menu if the menu icon is clicked
    if (e?.parentElement?.parentElement?.parentElement?.id !== 'menu_icon') {
      this.isMenuOpen = false;
    }
  }

  public toggleMute() {
    this.facade.toggleMuteState();
  }

  constructor(
    public facade: OmniChatFacade,
    public conversationsFacade: OmniConversationsFacade,
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.shouldFocusOnHeader?.currentValue) {
      this.headerTitle.nativeElement.focus();
      this.conversationsFacade.setHeaderFocus(false);
    }
  }

  ngAfterViewInit() {
    this.headerTitle.nativeElement.focus();
  }

  public backToDialog(): void {
    if (this.isHistory) {
      this.conversationsFacade.setConversationId(this.existingConvId);
    }
    this.facade.back();
  }

  public toggleChatState(): void {
    this.facade.toggleChatState();
  }

  public closeOrEndChat(close: boolean): void {
    if (close) {
      if (this.existingConvId) {
        this.conversationsFacade.endConversation(this.existingConvId);
      }
      this.conversationsFacade.setConversationId('');
      this.facade.closeDialog();
    } else {
      this.conversationsFacade.setCloseSplashScreen(true);
    }
  }
}
